// 客户费率模板

import { HttpBillManageList, HttpGetExportDetail } from '@/service/costbilling';
import comExcel from '@components/templates/excelalert';
import TableList from "@components/templates/tablelist";
import { mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    components: {
        comExcel
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            // Tabs: {show: true},
            // formData:{},
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            // Plugins: {show: true},
        };
    },
    methods: {
        ajaxRequest: HttpBillManageList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'query':
                    var url = this.$router.resolve({
                        name: "costbillingManageUpdate",
                        params: { type: "query" },
                        query: { id: params },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'export':
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB + "/api/v2/billing/bill/export", this.formData,
                        { executor: 'request', download: true }
                    );
                    break;
                case 'exportdetail':
                    // console.log(params.split(','))
                    if (params.split(',').length < 2) {
                        this.getExportDetail(params)
                    } else {
                        this.$VMessage.error('只能选择一条数据')
                    }
                    break;
            }
        },
        getExportDetail(params) {
            this.loading = true
            HttpGetExportDetail({ billId: params }).then(res => {
                this.$VMessage.success(res.message)
                this.loading = false
                this.operate = {
                    title: this.$t('global.common.export', { defaultValue: '导出' }),
                    show: true,
                    width: 560,
                    component: "comExcel",
                    showFooter: false
                }
            }, err => {
                this.$VMessage.error(err.message)
                this.loading = false
            })
        },
        getOperateNodeMap(row) {
            const { id } = row;
            return [{
                label: '查看',
                show: true,
                params: id,
                operate: 'query'
            }]
        },
    },
    computed: {
        ...mapGetters('dictionary', ['getBillcusorgList', 'getProductList', 'getBillcusWareList', 'getCusproductList']),
        ToolsData() {
            return [
                {
                    name: "导出",
                    operate: "export",
                    theme: "info",
                },
                {
                    name: "导出明细",
                    operate: "exportdetail",
                    theme: "success",
                    batch: true,
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: "组织",
                    key: 'EQ_organizationId',
                    show: true,
                    tag: 'vSelect',
                    options: this.getBillcusorgList,
                    props: {
                        filterable: true,
                    }
                },
                // {
                //     label: "仓库",
                //     key: 'EQ_warehouseId',
                //     show: true,
                //     tag: 'vSelect',
                //     options: this.getBillcusWareList,
                //     props: {
                //         filterable: true,
                //     },
                // },
                {
                    label: "账单编号",
                    key: 'EQ_billNo',
                    show: true,
                    tag: 'vInput',
                },
                {
                    label: "状态",
                    key: 'EQ_billStatus',
                    more: true,
                    tag: 'vSelect',
                    options: [
                        { value: 0, label: '已创建' },
                        { value: 1, label: '已确认' },
                    ],
                },
                {
                    label: "月份",
                    key: 'EQ_billingDate',
                    more: true,
                    tag: 'vDatepicker',
                    props: {
                        format: 'yy-mm',
                        confirm: false,
                    },
                },
                {
                    label: "项目",
                    key: 'EQ_lineId',
                    more: true,
                    tag: 'vSelect',
                    options: this.getCusproductList,
                    props: {
                        filterable: true,
                    }
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: '操作',
                    maxWidth: 90,
                    render: this.getOperateNodes
                }, {
                    title: '组织',
                    key: 'organizationName',
                }, 
                // {
                //     title: '仓库',
                //     key: 'orgWarehouseCode',
                // }, 
                {
                    title: '项目',
                    key: 'lineName',
                }, {
                    title: '账单编号',
                    // key: 'billNo',
                    render: (h, { row }) => {
                        return <div><a class="color-link" onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.billNo}</a></div>
                    }
                }, {
                    title: '状态',
                    key: 'billStatus',
                    render: (h, { row }) => {
                        return row.billStatus == 1 ? '已确认' : '已创建'
                    }
                }, {
                    title: '月份',
                    key: 'billingDate',
                }, {
                    title: '总费用',
                    key: 'totalCost',
                },
                {
                    title: '币种',
                    key: 'currency',
                },
                {
                    title: '更新时间',
                    key: 'createdAt',

                }];
        },
    },
};




